// ConsoleAnalyticsProvider: prints events to the browser console with branded,
// scannable styling. Zero setup, never fails - ideal for development and as a
// safe default. Uses console directly (not the leveled logger) so events always
// show. Events with props are grouped (collapsed) so the line stays concise.

// Branded console styles (Butterfly palette).
// Cream background + navy brand text so output is readable on dark AND light
// consoles (plain navy text was invisible on dark DevTools themes).
const S = {
  brand: 'background:#ff5d73;color:#faf0dc;font-weight:700;padding:2px 7px;border-radius:5px 0 0 5px',
  tag:   'background:#172047;color:#ffd14f;font-weight:600;padding:2px 7px;border-radius:0 5px 5px 0',
  stream:'background:#faf0dc;color:#172047;font-weight:600;padding:2px 6px;border-radius:4px',
  sep:   'color:#9aa3b2',
  event: 'background:#faf0dc;color:#172047;font-weight:700;padding:2px 8px;border-radius:4px',
  reset: 'color:inherit;font-weight:400',
  key:   'color:#27c4ac;font-weight:700',
};

export class ConsoleAnalyticsProvider {
  constructor(ctx = {}) {
    this.appId = ctx.appId || 'game';
  }

  async init() {
    console.info(
      `%cButterfly%canalytics%c ready | stream %c${this.appId}`,
      S.brand, S.tag, S.reset, S.stream,
    );
    return { ok: true };
  }

  event(name, props) {
    const hasProps = props && Object.keys(props).length > 0;
    const fmt = `%cButterfly%canalytics%c %c${this.appId}%c | %c${name}`;
    const styles = [S.brand, S.tag, S.reset, S.stream, S.sep, S.event];

    if (hasProps && typeof console.groupCollapsed === 'function') {
      console.groupCollapsed(fmt, ...styles);
      for (const [k, v] of Object.entries(props)) {
        console.info(`%c${k}%c`, S.key, S.reset, v);
      }
      console.groupEnd?.();
    } else {
      console.info(fmt, ...styles);
    }
  }
}



